import { CakeApiBase } from '../CakeApiBase';
import { AssetSwapRequestBody } from '../../schema/dex/asset-swap';

export class AssetSwapApi extends CakeApiBase {
  async swap(body: AssetSwapRequestBody) {
    return this.requestManager.post<any>('/asset-swap', body);
  }
}
